import { createRoot } from 'react-dom/client';
import './index.css';
import Dashboard from './dashboard/Dashboard.jsx';
import { HashRouter } from 'react-router-dom';
import { store } from './app/store';
import { Provider } from 'react-redux';
import React from 'react';
import { LicenseInfo } from '@mui/x-license';
import { CookiesProvider } from 'react-cookie';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

createRoot(document.getElementById('root')).render(
  <HashRouter>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
    <Provider store={store}>
      <Dashboard />
    </Provider>
    </CookiesProvider>
  </HashRouter>,
);
